module.exports = __webpack_public_path__ + "new-5455795b/template-1-52ec88d6a3ca88343e9f65c321dd5c7a.jpg";